import { Transition, DisclosurePanel } from "@headlessui/react";
import { FC, PropsWithChildren } from "react";

export const FAQItem: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Transition
      as="div"
      enter="transition duration-100 ease-out"
      enterFrom="transform scale-95 opacity-0"
      enterTo="transform scale-100 opacity-100"
      leave="transition duration-75 ease-out"
      leaveFrom="transform scale-100 opacity-100"
      leaveTo="transform scale-95 opacity-0"
    >
      <DisclosurePanel className="bg-jooalan-gray-50 p-4">
        {children}
      </DisclosurePanel>
    </Transition>
  );
};